const filterConfig = {
  type: 'object',
  properties: {
      search: {
          type: 'string',
      },
      status: {
          type: 'integer',
      }
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;
